import { g as getClosestVueParent } from './getClosestVueParent-2f2cbc16.js';
import __vue_component__$1 from './MdButton.js';
import __vue_component__$2 from './MdIcon.js';
import { n as normalizeComponent } from './normalize-component-cf2db48b.js';
import './MdInkRipple.js';
import './browser-ac904bdc.js';

const MdListItemExpand = {
  name: "md-list-item",
  components: {
    MdButton: __vue_component__$1,
    MdIcon: __vue_component__$2
  },
  props: {
    disabled: Boolean,
    createExpanded: {
      type: Boolean,
      default: false
    },
    mdExpandMultiple: Boolean,
    iconColor: {
      type: String,
      default: "currentColor"
    },
    disableInput: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      parentList: false,
      active: false,
      height: 0,
      contentObserver: null,
      transitionOff: true,
      mdiChevronDownIcon: null
    };
  },
  computed: {
    classes() {
      return {
        "md-disabled": this.disabled,
        "md-active": this.active
      };
    },
    expandClasses() {
      return {
        "md-transition-off": this.transitionOff
      };
    },
    expandStyles() {
      return {
        "margin-bottom": this.height
      };
    },
    disableInputClasses() {
      return {
        "disable-input": this.disableInput
      };
    }
  },
  async created() {
    const {
      mdiChevronDown
    } = await import('./mdiImports-f5901505.js');
    this.mdiChevronDownIcon = mdiChevronDown;
  },
  methods: {
    expandOnTab($event) {
      if (!this.active) {
        this.toggleExpandList($event);
      }
    },
    resetSiblings() {
      this.parentList.$children.forEach(child => {
        if (child.$el !== this.$el && child.$el.classList.contains("md-list-item-expand")) {
          child.active = false;
        }
      });
    },
    calculatePadding() {
      window.requestAnimationFrame(() => {
        if (this._destroyed) {
          return;
        }
        this.height = -this.$refs.expand.scrollHeight + "px";
        window.setTimeout(() => {
          this.transitionOff = false;
        });
      });
    },
    toggleExpandList($event) {
      if (!this.mdExpandMultiple) {
        this.resetSiblings();
      }
      this.calculatePadding();
      this.active = !this.active;
      this.$emit("click", $event);
    },
    recalculateAfterChange() {
      this.transitionOff = true;
      this.calculatePadding();
    },
    observeChildChanges() {
      this.contentObserver = new MutationObserver(this.recalculateAfterChange);
      this.contentObserver.observe(this.$refs.expand, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }
  },
  watch: {
    disableInput(newVal) {
      if (newVal && !this.active) {
        this.toggleExpandList();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.parentList = getClosestVueParent(this.$parent, "md-list");
      this.calculatePadding();
      this.observeChildChanges();
      window.addEventListener("resize", this.recalculateAfterChange);
      if (this.createExpanded) {
        this.toggleExpandList();
      }
    });
  },
  beforeDestroy() {
    if (this.contentObserver) {
      this.contentObserver.disconnect();
    }
    window.removeEventListener("resize", this.recalculateAfterChange);
    this._destroyed = true;
  }
};

const __vue_script__ = MdListItemExpand;
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('li', {
    staticClass: "md-list-item md-list-item-expand",
    class: _vm.classes
  }, [_c('div', {
    staticClass: "md-list-item-container md-button"
  }, [_vm._t("default"), _vm._v(" "), _c('md-icon', {
    staticClass: "md-list-expand-indicator",
    attrs: {
      "icon-svg": _vm.mdiChevronDownIcon,
      "icon-color": _vm.iconColor
    }
  })], 2), _vm._v(" "), _c('md-button', {
    staticClass: "md-button-ghost",
    class: _vm.disableInputClasses,
    attrs: {
      "type": "button",
      "disable-ripple": _vm.disableInput,
      "disabled": _vm.disabled,
      "border-style": 'none'
    },
    on: {
      "click": _vm.toggleExpandList
    }
  }), _vm._v(" "), _c('div', {
    ref: "expand",
    staticClass: "md-list-expand",
    class: _vm.expandClasses,
    style: _vm.expandStyles,
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")) {
          return null;
        }
        return _vm.expandOnTab.apply(null, arguments);
      }
    }
  }, [_vm._t("expand")], 2)], 1);
};
var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_module_identifier__ = undefined;
const __vue_is_functional_template__ = false;
const __vue_component__ = normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export { __vue_component__ as default };
